import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ALISA_IMAGES } from '@/data/moduleData';
import { useT } from '@/i18n';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

export const SpeechBubble = ({ text, emotion = 'neutral', showTyping = false, className = '' }) => {
  const t = useT();
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    if (!text) return;
    setDisplayText('');
    setIsTyping(true);
    let index = 0;
    const interval = setInterval(() => {
      if (index < text.length) {
        setDisplayText(text.slice(0, index + 1));
        index++;
      } else {
        setIsTyping(false);
        clearInterval(interval);
      }
    }, 18);
    return () => clearInterval(interval);
  }, [text]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.1 }}
      className={`flex items-end gap-2.5 ${className}`}
    >
      <Avatar className="h-8 w-8 border-2 border-primary/20 shrink-0">
        <AvatarImage src={ALISA_IMAGES.icon} alt={t('ui.alisa.name')} />
        <AvatarFallback className="bg-primary/10 text-primary text-xs font-heading font-bold">{t('ui.alisa.initial')}</AvatarFallback>
      </Avatar>
      <div className="flex-1">
        <div className="bg-card rounded-2xl rounded-bl-md px-4 py-3 shadow-soft border border-border/50">
          <p className="text-sm leading-relaxed text-card-foreground font-body">
            {displayText}
          </p>
        </div>
      </div>
    </motion.div>
  );
};
